import { render, staticRenderFns } from "./EditPersonalInfo.vue?vue&type=template&id=a7a9bfcc&"
import script from "./EditPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./EditPersonalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports